const entityMap = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#039;": "'",
    "&apos;": "'",
    "&nbsp;": " ",
    "&mdash;": "—"
    // Add more entity names and their corresponding characters as needed
};
// Matches any HTML entity, including numeric codes (&#123;), hexadecimal codes (&#x1F602;) or named entities (&lt;)
const decodeRegex = /&(?:#x?[0-9a-f]{2,}|[a-z]+);/gi;
/**
 * Decodes HTML entities in a string.
 * For example: "&amp;" becomes "&", "&#123;" becomes "{", "&#x1F602;" becomes "😂", etc.
 *
 * @param str The string to decode
 * @returns The decoded string
 */
export const decodeHTMLEntity = (str) => {
    if (!str.includes("&"))
        return str;
    return str.replace(decodeRegex, (entity) => {
        if (entity[1] === "#") {
            const code = entity[2] === "x" ? parseInt(entity.slice(3, -1), 16) : parseInt(entity.slice(2, -1), 10);
            return String.fromCodePoint(code);
        }
        return entityMap[entity] || entity;
    });
};
